import numbro from '@/helpers/numbro'
import { _plus, _percentage, _times, _toFixed, _div, _minus } from '@/helpers/bigNumber'
import { apificateDate } from '@/helpers/formatDate'

export const invoiceId = state => {
  return state.invoiceId
    ? state.invoiceId.serie
      ? `${state.invoiceId.serie}${state.invoiceId.number}`
      : state.invoiceId.number
    : undefined
}

export const brutto = state => {
  const _brutto = state.details.list.reduce((acc, k) => {
    return _plus(acc, state.details._[k].amount)
  }, 0)
  const result = _toFixed(_brutto, 2)
  return result
}

export const discountsByLine = state => {
  const _brutto = state.details.list.reduce((acc, k) => {
    return _plus(acc, state.details._[k].totalDiscounts)
  }, 0)
  const result = _toFixed(_brutto, 2)
  return result
}

export const linesBeforeTaxes = (state, getters) => {
  const result = _toFixed(_plus(getters['brutto'], getters['discountsByLine']), 2)
  return result
}

export const globalDiscounts = (state, getters) => {
  const result = _toFixed(getters['discountsCharges/total'], 2)
  return result
}

export const subtotalBeforeTaxes = (state, getters) => {
  const result = _toFixed(_plus(getters['linesBeforeTaxes'], getters['globalDiscounts']), 2)
  return result
}

export const taxes = (state, getters) => {
  let globalDiscount = getters['discountsCharges/totalAmount']
  let lines = state.details.list.length
  var taxesList = []
  var totalTaxes = 0
  state.details.list.forEach((k) => {
    let percentageTax = 0
    let typeTax = ''
    let gdPerLine = _div(globalDiscount, lines)
    let bruttoAmount = _plus(gdPerLine, state.details._[k].amountBeforeTaxes)
    if(state.details._[k].taxes.length > 0) {
      for (let i = 0; i < state.details._[k].taxes.length; i++) {
        percentageTax = state.details._[k].taxes[i].percent
        typeTax = state.details._[k].taxes[i].type.substring(0, 1)
        let taxRepeated = taxesList.find(linea => {
          if(linea.percentageTax === percentageTax && linea.typeTax === typeTax) {
            return linea
          }
        })
        let base = _plus(state.details._[k].amountBeforeTaxes, gdPerLine)
        let rawTax = _div(_times(base, percentageTax), 100)
        let taxAmount = _toFixed(rawTax, 2)
        var taxSummary = { bruttoAmount, percentageTax, typeTax, taxAmount }
        if(taxRepeated === undefined) {
          taxesList.push(taxSummary)
        } else {
          for(var cont = 0; cont < taxesList.length; cont++) {
            if(taxesList[cont] === taxRepeated) {
              taxesList.splice(cont, 1)
              break
            }
          }
          taxRepeated.bruttoAmount = _plus(taxRepeated.bruttoAmount, taxSummary.bruttoAmount)
          taxRepeated.taxAmount = _plus(taxRepeated.taxAmount, taxSummary.taxAmount)
          taxesList.push(taxRepeated)
        }
      }
    }
  })
  for(var tax of taxesList) {
    if(tax.typeTax === '8') { // Si es IRPF, restamos
      totalTaxes = _minus(totalTaxes, tax.taxAmount)
    } else {
      totalTaxes = _plus(totalTaxes, tax.taxAmount)
    }
  }
  totalTaxes = _toFixed(totalTaxes, 2)
  return totalTaxes
}

export const subtotal = (state, getters) => {
  const result = _toFixed(_plus(getters['subtotalBeforeTaxes'], getters['taxes']), 2)
  return result
}

export const total = (state, getters) => {
  const result = _toFixed(_plus(getters['subtotal'], getters['paymentsSpentsOthers/total'], getters['thirdPartyInvoices/total']), 2)
  return result
}

export const getGeneralSummary = state => {
  return {
    invoiceId: state.invoiceId.number
      ? state.invoiceId.serie
        ? `${state.invoiceId.serie}${state.invoiceId.number}`
        : state.invoiceId.number
      : undefined,
    format: state.format,
    created: state.created,
    onlySupplied: !state.type
      ? state.onlySupplied
        ? 'Sí'
        : 'No'
      : undefined,
    concept: state.concept
  }
}

export const getContactsSummary = (state, getters) => {
  return state.me === 'agent'
    ? {
      provider: getters['provider/getSubtitle'],
      agent: getters['agent/getSubtitle'],
      client: getters['client/getSubtitle']
    }
    : {
      provider: getters['provider/getSubtitle'],
      client: getters['client/getSubtitle'],
      customer: getters['customer/getSubtitle']
    }
}

export const getDetailsSummary = (state, getters) => {
  // En la tabla de líneas no se debe mostrar la suma de los descuentos/cargos globales
  return getters['details/getArray'].map(x => {
    let totalDiscounts = x.totalDiscounts
    // Redondeo por impuesto (criterio T3): en líneas multi-impuesto (ej. IVA 21% + IRPF 15%),
    // round(B * Σ%) difiere ±1 céntimo de Σ round(B * %) — el total por línea debe coincidir
    // con la suma de los importes de impuesto redondeados individualmente.
    let totalTaxes = _toFixed((x.taxes || []).reduce((acc, t) => {
      let taxAmount = _toFixed(_times(_plus(x.amountBeforeTaxes), _percentage(t.percent)), 2)
      return t.type.substring(0, 1) === '8'
        ? _minus(acc, taxAmount)
        : _plus(acc, taxAmount)
    }, 0), 2)
    let subtotalSummary = _toFixed(x.amountBeforeTaxes, 2)
    return Object.assign({}, x, {
      totalDiscounts, totalTaxes, subtotalSummary
    })
  })
}

/* TODO formatting here or in component? */
export const getAmountsSummary = (state, getters) => {
  // totalGross: suma de los subtotales de línea
  let totalGross = getters['linesBeforeTaxes']
  // totalDisc: Sólo Descuentos globales, los descuentos de línea ya se incluyen en totalGross
  let totalDisc = getters['globalDiscounts']
  let totalTaxes = getters['taxes']
  let totalOthers = _plus(getters['paymentsSpentsOthers/total'], getters['thirdPartyInvoices/total'])
  let totalSummary = getters['total']
  return {
    totalGross: numbro(totalGross).formatCurrency('0,0.00'),
    totalDisc: numbro(totalDisc).formatCurrency('0,0.00'),
    totalTaxes: numbro(totalTaxes).formatCurrency('0,0.00'),
    totalOthers: numbro(totalOthers).formatCurrency('0,0.00'),
    total: numbro(totalSummary).formatCurrency('0,0.00')
  }
}

export const apificate = (state, getters, rootState) => {
  let invoice = {}
  if (state.id) invoice.id = state.id
  if (state.invoiceId) invoice.invoiceId = { ...state.invoiceId }
  if (state.format) invoice.format = state.format
  if (state.created) invoice.created = apificateDate(state.created)
  if (state.issue) invoice.issue = apificateDate(state.issue)
  if (state.incomeDate) invoice.incomeDate = apificateDate(state.incomeDate)
  if (state.billProcedure && state.billProcedure.serie) invoice.billProcedure = { ...state.billProcedure }
  if (state.billPeriod && state.billPeriod.start && state.billPeriod.end) invoice.billPeriod = { ...state.billPeriod }
  if (invoice.billPeriod && invoice.billPeriod.start) invoice.billPeriod.start = apificateDate(invoice.billPeriod.start)
  if (invoice.billPeriod && invoice.billPeriod.end) invoice.billPeriod.end = apificateDate(invoice.billPeriod.end)
  if (state.concept) invoice.concept = state.concept
  if (state.fundProvision) invoice.fundProvision = state.fundProvision
  if (state.provider && state.provider.document) invoice.provider = getters['provider/apificate']
  if (state.client && state.client.document) invoice.client = getters['client/apificate']
  if (state.me === 'agent' && state.agent && state.agent.document) invoice.agent = getters['agent/apificate']
  else if (state.customer) {
    if (state.customerAsClient) invoice.customer = null
    else invoice.customer = getters['customer/apificate']
  }
  invoice.invoiceLines = getters['details/apificate']
  if (state.discountsCharges && state.discountsCharges.list.length > 0) invoice.discountsCharges = getters['discountsCharges/apificate']
  if (state.paymentsSpentsOthers && state.paymentsSpentsOthers.list.length > 0) invoice.paymentsSpentsOthers = getters['paymentsSpentsOthers/apificate']
  if (state.thirdPartyInvoices && state.thirdPartyInvoices.list.length > 0) invoice.thirdPartyInvoices = getters['thirdPartyInvoices/apificate']
  if (state.paymentIndications && state.paymentIndications.paymentType) invoice.paymentIndications = getters['paymentIndications/apificate']
  if (state.status) invoice.status = state.status
  if (state.locatorCode) invoice.locatorCode = state.locatorCode
  if (state.type === 'RECTIFIED' || state.type === 'PAYMENT') {
    invoice.paidRectified = state.paidRectified
  }
  if (state.me === 'agent') {
    invoice.onlySupplied = state.onlySupplied
  }
  invoice.totalGross = _toFixed(getters.linesBeforeTaxes, 2)
  invoice.totalDiscounts = _toFixed(getters.globalDiscounts, 2)
  // Total Taxes y Total se envían con 2 decimales
  invoice.totalTaxes = _toFixed(getters.taxes, 2)
  invoice.totalOthers = _toFixed(getters['paymentsSpentsOthers/total'], 2)
  invoice.total = _toFixed(getters.total, 2)
  invoice.type = state.type
  invoice.checkInmobilized = state.checkInmobilized
  // 70922 Regimen especial por caja se debe enviar en la factura
  invoice.specialRegime = !!rootState.me.settings.specialRegime
  // Factoring Borrox
  if (state.factoringContact && state.factoringContact.residence && state.factoringContact.document && state.factoringContact.corporateName) {
    invoice.invoiceFactoring = getters.apificateInvoiceFactoring
  }

  if (state.toDuplicate) {
    invoice.toDuplicate = state.toDuplicate
  }

  // FACeB2B - Se muestra como parte del cliente pero pertenece a la factura
  if (state.client.FACeB2B) {
    if (state.client.FACeB2B.buyerCentres.receiverAdministrativeCentre.code) {
      invoice.FACeB2B = state.client.FACeB2B
    } else invoice.FACeB2B = null
  }
  delete invoice.client.FACeB2B // se elimina del objeto para no pensar el flujo erroneamente
  return invoice
}

// Factoring Borrox
export const apificateInvoiceFactoring = (state, getters) => {
  let invoiceFactoring = {}
  invoiceFactoring.contact = getters['factoringContact/apificate']
  invoiceFactoring.payment = getters['factoringPaymentData/apificate']
  invoiceFactoring.assignmentReference = state.factoringReferences.assignmentReference
  invoiceFactoring.assignmentDocuments = getters['factoringTransferDocuments/apificate']
  return invoiceFactoring
}

export const isCreated = (state) => {
  return state.created < state.issue
}

export const loaded = (state) => {
  return state.loaded
}

const BK_RECOVERIES = '062500'

export const canAssets = (state, getters) => {
  return getters['client/contactMedium/isDepartment'](BK_RECOVERIES)
}

export const toInvoiceData = (state, getters) => {
  let invoice = {}
  if (state.id) invoice.id = state.id
  if (state.invoiceId) invoice.invoiceId = { ...state.invoiceId }
  if (state.created) invoice.created = state.created
  if (state.provider) invoice.provider = getters['provider/getDocumentAndName']
  if (state.client) invoice.client = getters['client/getDocumentAndName']
  if (state.me === 'agent' && state.agent) invoice.agent = getters['agent/getDocumentAndName']
  else if (state.customer) {
    if (state.customerAsClient) invoice.customer = null
    else invoice.customer = getters['customer/getDocumentAndName']
  }
  if (state.status) invoice.status = state.status
  invoice.amount = _toFixed(getters['total'], 2)
  return invoice
}

export const thirdPartyAttached = state => (item) => {
  return state.thirdPartyInvoices.list.some(x => x.id === item.id)
}
